import React, { useRef, useState } from "react";

import {
  ReportCellSettingsDropdown,
  ReportCellSettingsDropdownProps,
} from "./ReportCellSettingsDropDown";
import styles from "./ReportCellSettingsSelect.module.scss";
import { SettingsIcon } from "./assets";
import { useClickAway } from "react-use";

export const ReportCellSettingsSelect: React.FC<
  Omit<ReportCellSettingsDropdownProps, "handleClose">
> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    setIsOpen(!isOpen);
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - (rect.left + 200);
    const y = e.clientY - rect.top;
    setPosition({ x, y });
  };

  const handleClose = () => {
    setIsOpen(false);
  };
  const anchor = useRef(null);

  useClickAway(anchor, (e) => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  return (
    <div ref={anchor} style={{ position: "relative" }}>
      <div onClick={handleClick} className={styles.button}>
        <SettingsIcon />
      </div>
      {isOpen && (
        <ReportCellSettingsDropdown
          {...props}
          handleClose={handleClose}
          initialPosition={position}
        />
      )}
    </div>
  );
};
